/* eslint-disable */
import SceneBase from "./common/SceneBase";
import Helper from "./common/Helper";
import Particle from "./common/Particle";
import CharaPlayer from "./scene_play/chara/CharaPlayer";
import CharaPurpose from "./scene_play/chara/CharaPurpose";
import CharaGround from "./scene_play/chara/CharaGround";

class ScenePlay extends SceneBase {
  constructor(engine) {
    super(engine);

    this.step = "";

    this.distance;
    this.chargePer = 0;

    this.scene.enablePhysics(
      new BABYLON.Vector3(0, -9.81, 0),
      new BABYLON.CannonJSPlugin()
    );

    //particle
    this.particle = new Particle(this.scene);
  }

  //------------------------------------
  // setup
  //------------------------------------
  setup() {
    super.setup();

    //chara
    this.charaGround = new CharaGround(this.scene);
    this.charaGround.getMesh().parent = this.getRoot();

    this.charaPlayer = new CharaPlayer(this.scene);
    this.charaPurpose = new CharaPurpose(this.scene);

    this.charaPlayer.startAnimation("Go", false);
  }

  //------------------------------------
  // Camera
  //------------------------------------
  initCamera() {
    super.initCamera();
    this.camera.setPosition(new BABYLON.Vector3(0, 10, 60));
    this.camera.setTarget(new BABYLON.Vector3(0, 10, 0));
    this.scene.activeCamera = this.camera;
  }

  //------------------------------------
  // changeStatus
  //------------------------------------
  changeStatus(bool) {
    if (this.status !== bool) {
      if (bool) {
        this.particle.start();
      } else {
        this.particle.stop();
      }
    }

    super.changeStatus(bool);
  }

  //------------------------------------
  // Step Control
  //------------------------------------
  changeStep(step) {
    this.step = step;

    switch (this.step) {
      case "charge":
        //reset current step
        this.charaPlayer.resetPosition();
        this.chargePer = 0;
        this.cameraPosition = new BABYLON.Vector3(0, 10, 60);
        this.cameraTarget = new BABYLON.Vector3(0, 10, 0);

        this.wipeOpen();
        break;
      case "go":
        this.particle.updateScale(new BABYLON.Vector3(500, 500, 500));
        break;
      case "jump":
        this.particle.updateScale(new BABYLON.Vector3(500, 500, 500));
        break;
    }
  }

  changeMember(member) {
    this.charaPlayer.changeMember(member);
  }

  changeDistance(distance) {
    this.distance = distance;
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    if (this.status) {
      super.update();

      this.charaPlayer.update();

      let playerPos = this.charaPlayer.getPosition();

      switch (this.step) {
        case "charge":
          let y = Helper.getPlanetPosition(this.distance) * this.chargePer;

          this.updateCamera(
            new BABYLON.Vector3(0, y / 2, y * 2 + 60),
            new BABYLON.Vector3(0, y / 2, 0),
            10
          );

          let d = Helper.getPlanetPosition(this.distance);
          this.particle.updateScale(new BABYLON.Vector3(d * 2, d * 2, d * 2));
          this.particle.updatePosition(new BABYLON.Vector3(0, d / 2, 0));
          break;
        case "go":
          this.updateCamera(
            new BABYLON.Vector3(0, 15, 60),
            new BABYLON.Vector3(0, 15, 0),
            30
          );
          this.particle.updatePosition(playerPos);
          break;
        case "jump":
          this.updateCamera(
            new BABYLON.Vector3(0, playerPos.y / 2, playerPos.y / 4 + 60),
            new BABYLON.Vector3(-playerPos.x, playerPos.y, 0),
            5
          );
          this.particle.updatePosition(playerPos);
          break;
      }
    }
  }

  //------------------------------------
  // Play Control
  //------------------------------------
  dateUpdate(date) {
    this.particle.changeDate(date);
  }

  charge(per) {
    this.chargePer = per;
  }

  boost(result, power) {
    this.charaPurpose.setPurpose(this.distance);
    this.charaPlayer.boost(result, power, this.distance);
  }

  screenshot(func) {
    BABYLON.Tools.CreateScreenshot(
      this.engine,
      this.camera,
      { width: window.innerWidth, height: window.innerHeight },
      data => {
        func(data);
      }
    );
  }
}
export default ScenePlay;
